import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when an admin clicks Export CSV on the Audit Logs page',
  name: 'audit_log_export_requested',
  params: [
    {
      description: 'Workspace the export was requested for',
      name: 'workspace_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Inclusive start of the exported date range (ISO 8601)',
      name: 'start_date',
      required: true,
      type: 'string',
    },
    {
      description: 'Inclusive end of the exported date range (ISO 8601)',
      name: 'end_date',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
